import React, { useState, useEffect } from "react";
import { Button, Header, Input, Message, Modal, Table } from "react-frontier2";
import { SetLoading } from "@arema/components/Classes";
import { PromoterContact } from '../../AdminClasses';
import { bindFormChange } from "@arema/components/Util";
import { useUser } from "../../AdminHooks";
import API from "../../API";
import Validator from "@arema/components/Validator";
import UserAccess from "../../UserAccess";
import { useFrontier } from "react-frontier2";

interface PromoterContactCreateProps{
	open: boolean,
	onClose: ()=>void,
	promoter?: PromoterContact,
	promoterId: number,
	contact?: PromoterContact,
	onSaveContact?: (contact: PromoterContact)=>void,
	onDeleteContact?: (contact_id: number)=>void,
}

const PromoterContactCreate = (props: PromoterContactCreateProps)=>{
	var IS_CREATE = !props.contact;
	var { Toast } = useFrontier();
	var { hasAccess } = useUser();
	var [contact, setContact] = useState<PromoterContact>(null);
	var [errorPrompts, setErrorPrompts] = useState<string[]>(null);
	var [deleting, setDeleting] = useState<boolean>(false);

	useEffect(()=>{
		setDeleting(false);
		setContact(props.contact || {
			promoter_id: props.promoterId,
			contact_id: null,
			contact_name: '',
			department: '',
			email: '',
			phone: '',
		})
	}, [props.open, props.contact]);

	const submit = async (setLoading: SetLoading)=>{
		var { valid, prompts } = Validator(contact, {
			contact_name: [{
				rule: 'length', params: [4, 128], label: 'Nombre'
			}],
			department: [{
				rule: 'length', params: [4, 64], label: 'Departamento'
			}],
			email: [{
				rule: 'email', prompt: 'El correo electrónico no es válido'
			}],
			phone: [{
				rule: 'phone', skipEmpty: true, 
			}],
		});
		setErrorPrompts(prompts);
		if(!valid) return;
		if(IS_CREATE){
			contact.contact_id = null;
		}
		setLoading(true);
		if(IS_CREATE){
			API.createPromoterContact(props.promoterId, contact.contact_name, contact.department, contact.email, contact.phone).then(res=>{
				if(res.error) return setErrorPrompts([res.message]);
				Toast.success('Se ha creado el contacto del promotor');
				if(props.onSaveContact){
					var ct = { ...contact };
					ct.contact_id = res.data.contact_id;
					props.onSaveContact(ct);
				}else{
					window.location.reload();
				}
			}).catch(err=>{
				return setErrorPrompts(['Hubo un error inesperado creando el contacto (LCL-PRCTML-1)'])
			}).finally(()=>{
				setLoading(false);
			});
		}else{
			API.editPromoterContact(contact.contact_id, contact.contact_name, contact.department, contact.email, contact.phone).then(res=>{
				if(res.error) return setErrorPrompts([res.message]);
				Toast.success('Se ha editado el contacto del promotor');
				if(props.onSaveContact){
					props.onSaveContact(contact);
				}
			}).catch(err=>{
				return setErrorPrompts(['Hubo un error inesperado editando el contacto (LCL-PRCTML-2)'])
			}).finally(()=>{
				setLoading(false);
			});
		}
	}

	var showDelete = (val: boolean)=>{
		setErrorPrompts(null);
		setDeleting(val);
	}

	var deleteContact = (setLoading: SetLoading)=>{
		if(!contact?.contact_id || !hasAccess(UserAccess.CATALOGS.PROMOTER_DELETE_CONTACT)) return;
		setLoading(true);
		setErrorPrompts(null);
		API.deletePromoterContact(contact.contact_id).then(res=>{
			if(res.error) return setErrorPrompts([res.message]);
			Toast.success('Se ha eliminado el contacto del promotor');
			if(props.onDeleteContact) props.onDeleteContact(contact.contact_id);
			else window.location.reload();
		}).catch(err=>{
			return setErrorPrompts(['Hubo un error inesperado eliminando el contacto (LCL-PRCTML-3)'])
		}).finally(()=>{
			setLoading(false);
		})
	}

	var onChangeField = bindFormChange(contact, setContact);

	return (
		<Modal open={props.open} onClose={props.onClose} size="tiny">
			<Modal.Header>{!!props.contact?.contact_id ? (!deleting ? 'Editar' : 'Eliminar') : 'Crear'} contacto</Modal.Header>
			{!!contact && <Modal.Content>
				{!deleting ? <>
					<Input label="Nombre" value={contact.contact_name} onChange={onChangeField('contact_name')} />
					<Input label="Departamento" value={contact.department} onChange={onChangeField('department')} />
					<Input label="Correo electrónico" value={contact.email} onChange={onChangeField('email')} />
					<Input label="Teléfono" value={contact.phone} onChange={onChangeField('phone')} />
					<Message list={errorPrompts} type="error" style={{ marginTop: 15, marginBottom: 15 }} />

					{(!!props.contact?.contact_id && hasAccess(UserAccess.CATALOGS.PROMOTER_DELETE_CONTACT)) && (
						<Button basic color="red" text="Eliminar contacto" style={{ display: 'block', margin: 'auto', width: 200 }} onClick={()=>showDelete(true)} />
					)}
				</> : <>
					<Header text={'¿Eliminar contacto?'} subtext={`Se eliminará el contacto de ${contact.contact_name} del promotor`} />
					<Table details>
						<Table.Head title="Información" />
						<Table.Body data={[
							['ID', contact.contact_id],
							['Nombre', contact.contact_name],
							['Correo', contact.email],
							['Teléfono', contact.phone],
						]} />
					</Table>
					<Message list={errorPrompts} type="error" style={{ marginTop: 15 }} />
				</>}
			</Modal.Content>}
			<Modal.Actions>
				{!deleting ? <>
					<Button text="Cerrar" basic onClick={props.onClose} />
					<Button text="Guardar" color="black" onClick={submit} />
				</> : <>
					<Button text="Regresar" basic onClick={()=>showDelete(false)} />
					<Button text="Eliminar" color="red" onClick={deleteContact} />
				</>}
			</Modal.Actions>
		</Modal>
	)
}

export default PromoterContactCreate;